<template>
  <CCard>
    <CCardHeader>
      <slot name="header">
        <CIcon name="cil-https" /> {{ caption }}
        <div class="card-header-actions">
          <CButton color="success" size="sm" @click="exportData()">Exportar a Excel</CButton>
        </div>
      </slot>
    </CCardHeader>
    <CCardBody>
      <CDataTable :tableFilter="tableFilter" :hover="hover" :striped="striped" :border="border" :small="small"
        :fixed="fixed" :items="items" :fields="fields" :items-per-page="30" :dark="dark" pagination>
        <template #entity_code="{ item }">
          <td class="text-center w100">{{ item.entity_code }}</td>
        </template>
        <template #entity_name="{ item }">
          <td class="text-center w300">{{ item.entity_name }}</td>
        </template>
        <template #entity_type="{ item }">
          <td class="text-center w100">{{ item.entity_type_name }}</td>
        </template>        
        <template #type="{ item }">
          <td class="text-center w200">
            <div v-if="item.type == 'event_points'">Eventos y Conciertos</div>
            <div v-if="item.type == 'card_points'">Certificados Digitales</div>
            <div v-if="item.type == 'gift_points'">Premios en Especie</div>
            <div v-if="item.type == 'wallet_points'">Dépositos en Monedero</div>
          </td>
        </template>
        <template #points="{ item }">
          <td class="text-center w100">{{ item.points }}</td>
        </template>
        <template #date="{ item }">
          <td class="text-center w100">{{ item.date | date }}</td>
        </template>
      </CDataTable>
    </CCardBody>
  </CCard>
</template>

<script>
import ws from '../../services/awards';
import store from '../../store'
import router from '../../router/index'

export default {
  name: 'PendingAwardsTable',
  components: {},
  props: {
    items: Array,
    permissions: Object,
    fields: {
      type: Array,
      default() {
        return [
          { key: 'entity_code', label: 'Ruta' },
          { key: 'entity_name', label: 'Nombre' },
          { key: 'entity_type', label: 'Rol' },
          { key: 'type', label: 'Tipo de Puntos' },
          { key: 'name', label: 'Premio' },
          { key: 'points', label: 'Puntos' },
          { key: 'date', label: 'Fecha' },
        ]
      }
    },
    caption: {
      type: String,
      default: 'Table'
    },
    hover: Boolean,
    striped: Boolean,
    border: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean
  },
  data() {
    return {
      toasts: [],
      tableFilter: {
        label: 'Buscar: ',
        placeholder: '...'
      }
    }
  },
  methods: {
    async exportData() {
      this.loading();

      let response = await ws.getExcelPendings();

      if (response.type == "success") {
        window.location = response.data;
      }

      this.loaded();
    },
    showToast(type, message) {
      store.commit('toast', { color: type, message: message });
    },
    loading() {
      store.commit('loading');
    },
    loaded() {
      store.commit('loaded');
    },
    slugify(str) {
      return String(str)
        .normalize('NFKD') // split accented characters into their base characters and diacritical marks
        .replace(/[\u0300-\u036f]/g, '') // remove all the accents, which happen to be all in the \u03xx UNICODE block.
        .trim() // trim leading or trailing whitespace
        .toLowerCase() // convert to lowercase
        .replace(/[^a-z0-9 -]/g, '') // remove non-alphanumeric characters
        .replace(/\s+/g, '-') // replace spaces with hyphens
        .replace(/-+/g, '-'); // remove consecutive hyphens
    }
  }
}
</script>
